import routes from "./routes.json";
import faqs from "./faqs.json";

const byId = {};
const byPath = {};
routes.forEach((r) => {
  byId[r.id] = r;
  (r.idAliases || []).forEach((a) => { byId[a] = r; });
  byPath[r.path] = r;
});

export const ROUTES = routes;
export const FAQS = faqs;

export function normalizePath(p) {
  let x = String(p || "/").split("?")[0].split("#")[0].toLowerCase();
  if (x.length > 1) x = x.replace(/\/+$/, "");
  return x || "/";
}
export const routeForPath = (p) => byPath[normalizePath(p)] || byPath["/"];
export const pathToPage = (p) => routeForPath(p).id;
export const routeForPage = (id) => byId[id] || byPath["/"];
export const pageToPath = (id) => routeForPage(id).path;

/* Client-side navigation that still produces real URLs (History API). */
export function navigate(id) {
  const path = pageToPath(id);
  if (typeof window === "undefined") return;
  if (normalizePath(window.location.pathname) !== path) window.history.pushState({}, "", path);
  window.dispatchEvent(new Event("inov:navigate"));
}
